import { render, staticRenderFns } from "./TabAndamentoOre.vue?vue&type=template&id=531a854a&"
import script from "./TabAndamentoOre.vue?vue&type=script&lang=js&"
export * from "./TabAndamentoOre.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports